import { useMemo } from "react";

import { Type } from "@similarweb/ui-components";

import type { MetricFormat } from "app/common/benchmark/types";
import { getAxisPositions } from "../helpers";
import type { Axis } from "app/components/RankingAxis/types";

import AxisLine from "app/components/RankingAxis/AxisLine/AxisLine";
import { AxisDot, AxisLineWrapper, RankingAxisWrapper, StyledItemIcon } from "app/components/RankingAxis/styles";
import { TooltipGlobalStyle } from "app/components/RankingAxis/Tooltip/styles";
import Tooltip from "./Tooltip/Tooltip";

type AxisSchema = {
    data: Axis[];
    format: MetricFormat;
};

const RankingAxis = ({ data, format }: AxisSchema) => {
    const axisPositions = useMemo(() => getAxisPositions(data, format), [data, format]);

    return (
        <RankingAxisWrapper>
            <TooltipGlobalStyle />
            <AxisLineWrapper>
                {axisPositions?.positions?.length
                    ? axisPositions.positions.map((item, index) => (
                          <Tooltip
                              key={`${index}-${item.name}`}
                              data={item}
                          >
                              <AxisDot
                                  isPrimaryEntity={item?.isPrimaryEntity}
                                  position={item?.position}
                              >
                                  <StyledItemIcon
                                      iconSrc={item?.image}
                                      iconType={Type.Website}
                                  />
                              </AxisDot>
                          </Tooltip>
                      ))
                    : null}
                <AxisLine axisPositions={axisPositions} />
            </AxisLineWrapper>
        </RankingAxisWrapper>
    );
};

export default RankingAxis;
